import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setGDDKFilterConsumptionPeriod,
  getGDDKConsumptionListRequest,
} from '../../../redux/actions/gddk';
import {
  convertAmountToFrontend
} from "../../../helpers/convert";
import ComboBox from '../../../components/ComboBox';
import { Input } from '../../../components/Inputs';
import Button from '../../../components/Button';
import DataTable from '../../../components/DataTable';
import EmptyState from '../../../components/EmptyState/EmptyState';
import Loading from '../../../components/Loading';
import moment from 'moment';

const ConsumptionDataGDDKOperations = ({ t }) => {
  const dispatch = useDispatch();
  const selectedOrganization = useSelector(
    (state) => state.organizations.selectedOrganization
  );
  const {
    filterConsumptionPeriod,
    consumptionList,
    consumptionAmount,
    consumptionAmountAfterGDDK,
    consumptionLoading,
  } = useSelector((state) => state.gddk);

  const [filteredPeriod, setFilteredPeriod] = useState(null);

  const translations = {
    1: t('ui.default.months.1'),
    2: t('ui.default.months.2'),
    3: t('ui.default.months.3'),
    4: t('ui.default.months.4'),
    5: t('ui.default.months.5'),
    6: t('ui.default.months.6'),
    7: t('ui.default.months.7'),
    8: t('ui.default.months.8'),
    9: t('ui.default.months.9'),
    10: t('ui.default.months.10'),
    11: t('ui.default.months.11'),
    12: t('ui.default.months.12'),
  };

  const consumptionListColumns = [
    {
      name: t('pages.default.certificates.table.organizationName'),
      selector: 'organizationName',
      sortable: true,
      showTitle: true,
    },
    {
      name: t('pages.default.gddkOperations.table.consumptionPeriod'),
      selector: 'consumptionPeriod',
      sortable: true,
      cell: (row) => {
        const term = moment(row.term);
        return `${translations[term.month() + 1]} ${term.year()}`;
      },
    },
    {
      name: t('pages.default.gddkOperations.table.gddkPeriod'),
      selector: 'gddkPeriod',
      sortable: true,
      cell: (row) => {
        const gddTerm = moment(row.gddkTerm);
        return `${translations[gddTerm.month() + 1]} ${gddTerm.year()}`;
      },
    },
    {
      name: t('pages.default.gddkOperations.table.gddkAmount'),
      selector: 'amount',
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.amount);
      },
    },
  ];

  const handleChangeConsumptionPeriod = (e) => {
    dispatch(setGDDKFilterConsumptionPeriod(e.target.value.replace('-', '')));
  };

  const filterConsumptionList = () => {
    dispatch(
      getGDDKConsumptionListRequest({
        organizationId:
          selectedOrganization && Object.keys(selectedOrganization).length > 0
            ? selectedOrganization.organizationId
            : '',
        term: filterConsumptionPeriod,
      })
    );
    setFilteredPeriod(filterConsumptionPeriod);
  };

  return (
    <div className='km__p--card'>
      <div className='km__p--gddk-header'>
        <div className='km__u--text_title'>
          {t('pages.default.gddkOperations.greenTariffGDDKTitle')}
        </div>
      </div>
      <div className='km__p--gddk-filter-container'>
        <ComboBox t={t} />
        <Input
          type='month'
          name='consumptionPeriod'
          value={filterConsumptionPeriod}
          placeholder={t(
            'pages.default.gddkOperations.filters.allConsumptionPeriods'
          )}
          onChange={handleChangeConsumptionPeriod}
        />
        <Button
          label={t('ui.default.filter')}
          onClick={filterConsumptionList}
          disabled={
            !selectedOrganization || !selectedOrganization.organizationId
          }
        />
      </div>
      {selectedOrganization && selectedOrganization.organizationId && (
        <>
          {!consumptionLoading && (
            <DataTable
              columns={consumptionListColumns}
              data={consumptionList}
              rowKey='id'
              pagination
              paginationPerPage={10}
            />
          )}
          {consumptionList.length === 0 && !consumptionLoading && (
            <EmptyState
              icon='file-text'
              text={t('pages.default.gddkOperations.consumptionNotFound')}
            />
          )}
          {consumptionLoading && (
            <Loading
              text={t('pages.default.gddkOperations.consumptionLoading')}
            />
          )}

          {filteredPeriod && consumptionList.length > 0 && !consumptionLoading && (
            <div className='km__p--gddk-score-container'>
              <div className='km__u--text_title'>
                <div>{t('pages.default.gddkOperations.consumptionAmount')}</div>
                <div className='km__u--text-yellow-300'>
                  {consumptionAmount ? `${consumptionAmount} MWh` : '-'}
                </div>
              </div>
              <div className='km__u--text_title'>
                <div>
                  {t(
                    'pages.default.gddkOperations.consumptionAmountAfterGDDKTitle'
                  )}
                </div>
                <div className='km__u--text-green-300'>
                  {consumptionAmountAfterGDDK
                    ? `${consumptionAmountAfterGDDK} MWh`
                    : '-'}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ConsumptionDataGDDKOperations;
